module.exports = __webpack_public_path__ + "static/img/logo.0f341d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 11